import { create } from 'zustand';

import { type ClipboardActions, type ClipboardState } from './types';

export const useClipboardStore = create<ClipboardState & ClipboardActions>((set) => ({
  clearClipboard: () => set({ clipboard: null }),
  clipboard: null,
  setClipboard: (item) => set({ clipboard: item }),
}));
